import { render, staticRenderFns } from "./CiModalDialog.vue?vue&type=template&id=37b6afbe&scoped=true&"
import script from "./CiModalDialog.vue?vue&type=script&lang=js&"
export * from "./CiModalDialog.vue?vue&type=script&lang=js&"
import style0 from "./CiModalDialog.vue?vue&type=style&index=0&id=37b6afbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6afbe",
  null
  
)

component.options.__file = "CiModalDialog.vue"
export default component.exports